<div
  *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.Size"
  class="product-column-general product-size"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'">
  {{ rowVm | sectionRowViewModelBasicMethod: 'getSize' }}
</div>
